module.exports = __webpack_public_path__ + "img/sports.064537a2.png";